var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBlobLeft = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131.165,
    height: 90.824,
    viewBox: "0 0 131.165 90.824",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blob-left-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#146a61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72a6a0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blob-left-gradient)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M-1031.082 62.832v-89.483h130.118c-1.97 22.118-52.98 25.217-70.868 54.3-15.33 24.925-34.623 35.524-53.4 35.525a50.547 50.547 0 0 1-5.85-.342z",
    transform: "translate(1031.582 27.151)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlobLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blob-left.a54cdc74.svg";
export { ForwardRef as ReactComponent };